module.exports = {
	"firstName": "deau",
	"name": "deau",
	"shortname": "deau",
	"website_handle": "dominiquecandido.com",
	"website_url": "http://www.dominiquecandido.com/",
	"instagram_handle": "deau0",
	"instagram_url": "https://www.instagram.com/deau0/",
	"description": "Stylist Dominique shares her fashion love through her online style diary DEAU. Living in Amsterdam, The Netherlands, DEAU covers outfits, travel stories and moodboards meant to instigate creativity and inspire.",
	"interview": [
		{
			"title": "1. How would you describe your aesthetic and how did you apply it to the collection?",
			"description": "I would say that my style is very minimalistic although I like to also add a little bit of a cool edge every now and then. When I was thinking about my collection I knew that this was something I wanted to apply to it. I think I was able to create this by keeping the colours in the pieces simple while playing with the details."
		},
		{
			"title": "2. Four things that you always have in your bag?",
			"description": "My bag would feel totally empty without: lip balm, because one needs to keep lips from chapping, perfume, because you never know who you’ll bump into, Powerbank, because I’d be lost without my phone, and finally my wallet… and that one is obvious."
		},
		{
			"title": "3. Sneakers or heels?",
			"description": "I have to say sneakers all the way! I just recently did a post on my blog about them. Even if heels are fancy and beautiful, sneakers are just so much more comfortable! Nowadays and with the latest trends, sneakers can be can be just as stylish and much more versatile."
		}
	],
	"quote": "You should make it simple, but remarkable",
	"media": [
		"/media/img/influencers/deau/deau_slider-2.jpg",
		"/media/img/influencers/deau/deau_slider-3.jpg",
		"/media/img/influencers/deau/deau_slider-1.jpg",
		"/media/img/influencers/deau/deau_slider-4.jpg"
	],
	"socialItems": [
		{
			"url": "https://www.instagram.com/p/BI-sxxIh6eU/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13827439_288317544867103_1141593954_n.jpg?ig_cache_key=MTMxNDY4NTA3NTI5NjA2OTUyNA%3D%3D.2",
			"likes": 1322
		},
		{
			"url": "https://www.instagram.com/p/BJBDPu5Bwkh/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13627938_1727085120885071_852856237_n.jpg?ig_cache_key=MTMxNTM0Njg0MTQ0OTQ2NjE0NQ%3D%3D.2",
			"likes": 2724
		},
		{
			"url": "https://www.instagram.com/p/BJdUDPtB1x8/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14099728_796164083857538_699327739_n.jpg?ig_cache_key=MTMyMzMwMjA0OTQ2NzAzMDY1Mg%3D%3D.2",
			"likes": 1842
		},
		{
			"url": "https://www.instagram.com/p/BKYiLyGBSBf/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14310752_1787155974858468_1764010363_n.jpg?ig_cache_key=MTMzOTk3MTIzMjQyNjQzNDY1NQ%3D%3D.2",
			"likes": 1123
		},
		{
			"url": "https://www.instagram.com/p/BKnzdcAB9sP/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14350556_1723123844617091_3900088050050400256_n.jpg?ig_cache_key=MTM0NDI2OTMzNzA5NTU1OTk1MQ%3D%3D.2",
			"likes": 1100
		},
		{
			"url": "https://www.instagram.com/p/BMUZicKDoCf/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14726391_319117711808932_6034196654494580736_n.jpg?ig_cache_key=MTM3NDgzNjEwNDExMzMyNDE5MQ%3D%3D.2",
			"likes": 2149
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/influencers/deau.json
// module id = 75
// module chunks = 0